(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ess-world-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initConstellation() {
    document.querySelectorAll('.ess-home__cosmos').forEach(function (cosmos) {
      if (cosmos.dataset.essConstellationReady === 'true') return;
      cosmos.dataset.essConstellationReady = 'true';

      function converge() {
        cosmos.classList.remove('is-ess-visible', 'is-resetting');
        cosmos.classList.add('is-converging');

        window.setTimeout(function () {
          cosmos.classList.add('is-ess-visible');
        }, 1300);

        window.setTimeout(function () {
          cosmos.classList.add('is-resetting');
          cosmos.classList.remove('is-ess-visible');
        }, 3400);

        window.setTimeout(function () {
          cosmos.classList.remove('is-converging', 'is-resetting');
        }, 4300);
      }

      window.setTimeout(converge, 2600);
      window.setInterval(converge, 9800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConstellation);
  } else {
    initConstellation();
  }

  function initTransmissions() {
    document.querySelectorAll('[data-ess-transmissions]').forEach(function (section) {
      if (section.dataset.transmissionsReady === 'true') return;
      section.dataset.transmissionsReady = 'true';

      var viewport = section.querySelector('.ess-home__transmission-viewport');
      var rows = Array.from(section.querySelectorAll('[data-transmission-row]'));
      var prev = section.querySelector('[data-transmissions-prev]');
      var next = section.querySelector('[data-transmissions-next]');
      var current = 0;
      var animating = false;
      var paused = false;
      var autoTimer = null;
      if (!viewport || rows.length < 2) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        var cards = Array.from(section.querySelectorAll('.ess-home__transmission-card'));
        if (!cards.length) return;
        var mobileIndex = 0;
        var mobileTimer = null;
        section.classList.add('ess-home__signal--mobile-carousel');
        function showMobileCard(index) {
          mobileIndex = (index + cards.length) % cards.length;
          rows.forEach(function (row) {
            row.classList.toggle('is-active', row.contains(cards[mobileIndex]));
          });
          cards.forEach(function (card, i) {
            card.classList.toggle('is-mobile-current', i === mobileIndex);
            card.setAttribute('aria-hidden', i === mobileIndex ? 'false' : 'true');
            card.tabIndex = i === mobileIndex ? 0 : -1;
          });
          viewport.style.height = (cards[mobileIndex].offsetHeight + 16) + 'px';
        }
        function stopMobile() { if (mobileTimer) window.clearInterval(mobileTimer); mobileTimer = null; }
        function startMobile() {
          stopMobile();
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          mobileTimer = window.setInterval(function () { showMobileCard(mobileIndex + 1); }, 4200);
        }
        if (prev) prev.addEventListener('click', function () { showMobileCard(mobileIndex - 1); startMobile(); });
        if (next) next.addEventListener('click', function () { showMobileCard(mobileIndex + 1); startMobile(); });
        section.addEventListener('focusin', stopMobile);
        section.addEventListener('focusout', startMobile);
        section.addEventListener('touchstart', stopMobile, { passive: true });
        section.addEventListener('touchend', startMobile, { passive: true });
        window.addEventListener('resize', function () { showMobileCard(mobileIndex); });
        cards.forEach(function (card) {
          var img = card.querySelector('img');
          if (img) img.addEventListener('load', function () { showMobileCard(mobileIndex); });
        });
        showMobileCard(0);
        startMobile();
        return;
      }

      function syncHeight() {
        var tallest = 0;
        rows.forEach(function (row) {
          var previous = row.style.visibility;
          row.style.visibility = 'hidden';
          row.style.transform = 'none';
          row.style.opacity = '1';
          tallest = Math.max(tallest, row.scrollHeight);
          row.style.visibility = previous;
          row.style.transform = '';
          row.style.opacity = '';
        });
        if (tallest > 0) viewport.style.height = (tallest + 16) + 'px';
      }

      function switchRow(direction) {
        if (animating) return;
        animating = true;

        var outgoing = rows[current];
        var incomingIndex = current === 0 ? 1 : 0;
        var incoming = rows[incomingIndex];

        incoming.classList.remove('is-active','is-exiting-up','is-exiting-down','is-entering-up','is-entering-down');
        incoming.classList.add(direction > 0 ? 'is-entering-up' : 'is-entering-down');

        incoming.getBoundingClientRect();

        requestAnimationFrame(function () {
          outgoing.classList.add(direction > 0 ? 'is-exiting-up' : 'is-exiting-down');
          incoming.classList.add('is-active');
          incoming.classList.remove(direction > 0 ? 'is-entering-up' : 'is-entering-down');
        });

        window.setTimeout(function () {
          outgoing.classList.remove('is-active','is-exiting-up','is-exiting-down');
          current = incomingIndex;
          animating = false;
        }, 980);
      }

      function stopAuto() {
        if (autoTimer) window.clearInterval(autoTimer);
        autoTimer = null;
      }

      function startAuto() {
        stopAuto();
        if (paused) return;
        autoTimer = window.setInterval(function () { switchRow(1); }, 6800);
      }

      if (prev) prev.addEventListener('click', function () {
        switchRow(-1);
        startAuto();
      });

      if (next) next.addEventListener('click', function () {
        switchRow(1);
        startAuto();
      });

      section.addEventListener('mouseenter', function () { paused = true; stopAuto(); });
      section.addEventListener('mouseleave', function () { paused = false; startAuto(); });
      section.addEventListener('focusin', function () { paused = true; stopAuto(); });
      section.addEventListener('focusout', function () { paused = false; startAuto(); });

      window.addEventListener('resize', syncHeight);
      window.setTimeout(syncHeight, 60);
      window.setTimeout(syncHeight, 500);
      startAuto();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransmissions);
  } else {
    initTransmissions();
  }

  document.addEventListener('shopify:section:load', function () {
    initConstellation();
    initTransmissions();
  });
})();

(() => {
  const instances = new Map();
  const mount = (root) => {
    root.querySelectorAll('[data-living-star]').forEach((host) => {
      if (instances.has(host)) return;
      const field = host.querySelector('.ess-living-star__field');
      const canvas = host.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const labels = Array.from(host.querySelectorAll('.ess-living-star__label'));
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let frame = 0, elapsed = 0, last = 0, visible = false;
      let cursorX = 0, cursorY = 0, driftX = 0, driftY = 0, size = 0;
      const clamp = (v) => Math.max(0, Math.min(1, v));
      const smooth = (v) => { v = clamp(v); return v * v * (3 - 2 * v); };
      const rings = [
        { radius: 153, depth: 49, tilt: -.48 },
        { radius: 136, depth: 62, tilt: .72 },
        { radius: 146, depth: 38, tilt: 1.65 },
        { radius: 112, depth: 51, tilt: -.82 },
        { radius: 162, depth: 43, tilt: .24 }
      ];
      const point = (i, angle, theta) => {
        const tilt = -.3 + Math.sin(theta) * .08 + driftX * .003;
        const x = Math.cos(angle) * 139;
        const y = Math.sin(angle) * (113 + Math.sin(theta) * 7 + driftY * .15);
        const orbitX=200+x*Math.cos(tilt)-y*Math.sin(tilt)+driftX;
        const orbitY=200+x*Math.sin(tilt)+y*Math.cos(tilt)+driftY;
        const formed=smooth((-Math.cos(theta)-.18)/.52);
        const starAngle=angle+tilt;
        const starX=200+Math.cos(starAngle)*132+driftX;
        const starY=200+Math.sin(starAngle)*132+driftY;
        return {x:orbitX+(starX-orbitX)*formed,y:orbitY+(starY-orbitY)*formed};
      };
      const glow = (x,y,radius,strength) => {
        const halo=ctx.createRadialGradient(x,y,0,x,y,radius*6);
        halo.addColorStop(0,'rgba(255,255,255,'+strength+')');
        halo.addColorStop(.2,'rgba(255,255,255,'+strength*.35+')');
        halo.addColorStop(1,'rgba(255,255,255,0)');
        ctx.fillStyle=halo;ctx.beginPath();ctx.arc(x,y,radius*6,0,Math.PI*2);ctx.fill();
        ctx.fillStyle='rgba(255,255,255,'+strength+')';
        ctx.beginPath();ctx.arc(x,y,radius,0,Math.PI*2);ctx.fill();
      };
      const paint = () => {
        const theta = (elapsed % 24000) / 24000 * Math.PI * 2;
        const formed=smooth((-Math.cos(theta)-.18)/.52);
        host.dataset.phase=formed>.99?'star':formed>.01?'converge':'orbit';
        ctx.clearRect(0,0,400,400);
        const core=ctx.createRadialGradient(200+driftX,200+driftY,6,200+driftX,200+driftY,76);
        core.addColorStop(0,'rgba(0,0,0,.92)');
        core.addColorStop(.55,'rgba(0,0,0,.72)');
        core.addColorStop(1,'rgba(0,0,0,0)');
        ctx.fillStyle=core;ctx.fillRect(100,100,200,200);
        rings.slice(0,3).forEach((ring,i)=>{
          const tilt=ring.tilt+Math.sin(theta+i)*.13+driftX*.003;
          ctx.beginPath();
          for(let j=0;j<=120;j++){
            const a=j/120*Math.PI*2;
            const x=Math.cos(a)*ring.radius;
            const y=Math.sin(a)*(ring.depth+driftY*.2);
            const px=200+x*Math.cos(tilt)-y*Math.sin(tilt)+driftX;
            const py=200+x*Math.sin(tilt)+y*Math.cos(tilt)+driftY;
            if(j===0)ctx.moveTo(px,py);else ctx.lineTo(px,py);
          }
          ctx.strokeStyle='rgba(255,255,255,'+(.12+i*.025)*(1-formed*.88)+')';ctx.lineWidth=.65;ctx.stroke();
        });
        const starPoints=labels.map((label,i)=>point(i,theta+i*Math.PI*2/5+Math.PI/2,theta));
        const starOrder=[0,2,4,1,3];
        if(formed>.01){
          ctx.beginPath();
          starOrder.forEach((index,i)=>{const p=starPoints[index];if(i===0)ctx.moveTo(p.x,p.y);else ctx.lineTo(p.x,p.y);});
          ctx.closePath();ctx.strokeStyle='rgba(255,255,255,'+formed*formed*.68+')';ctx.lineWidth=.8;ctx.stroke();
        }
        labels.forEach((label,i)=>{
          const angle=theta+i*Math.PI*2/5+Math.PI/2;
          const p=point(i,angle,theta);
          for(let j=24;j>0;j--){
            const a=point(i,angle-j*.018,theta);
            const b=point(i,angle-(j-1)*.018,theta);
            ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);
            ctx.strokeStyle='rgba(255,255,255,'+(1-j/25)*.48*(1-formed)+')';ctx.lineWidth=1.1;ctx.stroke();
          }
          glow(p.x,p.y,2.3+.25*Math.sin(theta+i),.9);
          const dx=p.x-200-driftX,dy=p.y-200-driftY;
          const length=Math.hypot(dx,dy);
          const anchorX=(1-dx/length)/2,anchorY=(1-dy/length)/2;
          const labelWidth=label.offsetWidth/size*400,labelHeight=label.offsetHeight/size*400;
          const x=Math.max(8+labelWidth*anchorX,Math.min(392-labelWidth*(1-anchorX),p.x+dx/length*16));
          const y=Math.max(8+labelHeight*anchorY,Math.min(392-labelHeight*(1-anchorY),p.y+dy/length*16));
          label.style.left=x/4+'%';label.style.top=y/4+'%';
          label.style.transform='translate('+(-anchorX*100)+'%,'+(-anchorY*100)+'%)';
        });
        ctx.beginPath();ctx.ellipse(200+driftX,200+driftY,32,10,-.4+Math.sin(theta)*.08,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+.32*(1-formed)+')';ctx.lineWidth=1;ctx.stroke();
      };
      const resize = () => {
        const width=field.getBoundingClientRect().width;
        if(!width)return;
        size=width;
        const ratio=Math.min(window.devicePixelRatio||1,2);
        canvas.width=Math.round(width*ratio);canvas.height=canvas.width;
        ctx.setTransform(canvas.width/400,0,0,canvas.height/400,0,0);
        if(!motion.matches)paint();
      };
      const tick = (now) => {
        if(!host.isConnected || motion.matches || !visible || document.hidden){last=0;frame=0;return;}
        if(last)elapsed+=Math.min(now-last,250);
        last=now;
        driftX+=(cursorX-driftX)*.045;driftY+=(cursorY-driftY)*.045;
        if(size)paint();
        frame=requestAnimationFrame(tick);
      };
      const sync = () => {
        cancelAnimationFrame(frame);frame=0;last=0;
        host.classList.toggle('is-active',!motion.matches);
        if(motion.matches){host.dataset.phase='still';labels.forEach((label,i)=>{label.style.left=['50%','17.25%','29.75%','70.25%','82.75%'][i];label.style.top=['84.5%','60.75%','22%','22%','60.75%'][i];label.style.transform='translate(-50%,1rem)';});}
        else if(visible&&!document.hidden)frame=requestAnimationFrame(tick);
      };
      field.addEventListener('pointermove',(event)=>{
        if(motion.matches||event.pointerType==='touch')return;
        const rect=field.getBoundingClientRect();
        cursorX=(clamp((event.clientX-rect.left)/rect.width)-.5)*32;
        cursorY=(clamp((event.clientY-rect.top)/rect.height)-.5)*26;
      },options);
      field.addEventListener('pointerleave',()=>{cursorX=0;cursorY=0;},options);
      motion.addEventListener('change',sync,options);
      document.addEventListener('visibilitychange',sync,options);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();});
      const resizer=new ResizeObserver(resize);
      observer.observe(host);resizer.observe(field);resize();sync();
      instances.set(host,()=>{controller.abort();observer.disconnect();resizer.disconnect();cancelAnimationFrame(frame);});
    });
  };
  mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((destroy,host)=>{if(event.target.contains(host)){destroy();instances.delete(host);}});
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
